// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__3xyR4","error":"InputSecondary_error__1uWQq","disabled":"InputSecondary_disabled__f_GS9"};